export default {
  name: 'Footer',
  methods: {
    topRD() {
      this.$router.push(this.$router.currentRoute._value.path)
    },
    homeRD() {
      this.$router.push('/home')
    },
    downloadResume() {
      window.open('../../assets/Resume.pdf')
    },
    pageRD(page) {
      switch (page) {
        case 'contact':
          this.$router.push('/contact')
          break
        case 'home':
          this.$router.push('/home')
          break
        case 'work':
          this.$router.push('/home/workShowcase')
          break
        case 'resume':
          this.$router.push('/home/resumeShowcase')
          break
        default: break
      }
    },
    mediaRD(media) {
      media === 'instagram' ? window.open('https://www.instagram.com/egelder.18/') : window.open('https://www.linkedin.com/in/emilygelder/')
    }
  }
}